// extracted by mini-css-extract-plugin
module.exports = {"border":"BlogDetail_border__isww6"};